import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { userRegister } from "../../redux/actions";

class Register extends PureComponent {
  state = {
    name: "",
    lastname: "",
    email: "",
    password: "",
    company: "",
    phone: "",
    error: "",
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.user.register === false) {
      this.setState({ error: "Error, try again" });
    } else {
      this.setState({
        name: "",
        lastname: "",
        email: "",
        password: "",
        company: "",
        phone: "",
        error: "",
      });
    }
  }

  handleInput = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  submitForm = (e) => {
    e.preventDefault();
    this.setState({ error: "" });
    this.props.dispatch(
      userRegister({
        email: this.state.email,
        password: this.state.password,
        name: this.state.name,
        lastname: this.state.lastname,
        company: this.state.company,
        phone: this.state.phone,
      })
    );
  };

  render() {
    return (
      <div className="container">
        <section className="form-elegant">
          <div className="card rounded-lg shadow-lg p-5">
            <div className="card-body mx-4">
              <div className="text-center">
                <h3 className="mb-5" style={{ color: '#2F2B5D' }}>
                  <strong>Register</strong>
                </h3>
              </div>
              <form onSubmit={this.submitForm}>
                {["name", "lastname", "company", "email", "phone", "password"].map((field, idx) => (
                  <div className="md-form mb-4" key={idx}>
                    <input
                      type={field === "email" ? "email" : field === "password" ? "password" : "text"}
                      className="form-control"
                      style={{ borderBottom: '2px solid #FFA500' }}
                      value={this.state[field]}
                      onChange={this.handleInput(field)}
                    />
                    <label style={{ color: '#555' }}>
                      {field.charAt(0).toUpperCase() + field.slice(1)}
                    </label>
                  </div>
                ))}
                <div className="text-center mt-4">
                  <button
                    type="submit"
                    className="btn btn-block rounded-pill"
                    style={{ backgroundColor: '#FFA500', borderColor: '#FFA500' }}
                  >
                    Register
                  </button>
                </div>
                {this.state.error && (
                  <div className="text-danger text-center mt-3">
                    {this.state.error}
                  </div>
                )}
              </form>
              <p className="text-center mt-3">or Connect with:</p>
              <div className="d-flex justify-content-center">
                {["facebook", "twitter", "google-plus"].map((social, idx) => (
                  <button type="button" className="btn btn-light mx-2" key={idx}>
                    <i className={`fa fa-${social} text-warning`} />
                  </button>
                ))}
              </div>
            </div>
            <div className="card-footer text-right">
              <p>
                Have an account?{" "}
                <Link to="/login" className="text-warning ml-1">
                  Log In
                </Link>
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ user: state.user });
export default connect(mapStateToProps)(Register);



// WEBPACK FOOTER //
// ./src/containers/Admin/register.js